import { DEFAULT_MAX_IMG_SIZE } from '../../../../../../../../../assets/utils/constants';
import ImagesInput from '../../../../../../../ImagesInput/ImagesInput';
import PlatformInput from '../../../../../../../PlatformInput/PlatformInput';
import './PromoTextPicture.css';

const PROMO_IMAGE_HINT = `Рекомендуемый формат: 4:3. Не более ${DEFAULT_MAX_IMG_SIZE} Мб`;
const PROMO_IMAGE_TABLET_HINT = `Рекомендуемый формат: 4:3. Не более ${DEFAULT_MAX_IMG_SIZE} Мб`;
const PROMO_IMAGE_MOBILE_HINT = `Рекомендуемый формат: 4:3. Не более ${DEFAULT_MAX_IMG_SIZE} Мб`;

function PromoTextPicture({ item, handleChange }) {
    return (
        <div className='promo-text-picture'>
            <PlatformInput
                label={'Заголовок'}
                value={item.data[0].title}
                handleChange={(e) => {
                    handleChange({
                        target: {
                            index: 0,
                            value: e.target.value,
                            item: item,
                            name: 'promo-text-image',
                            subname: 'title',
                        }
                    })
                }}
                isTextArea={true}
                minRows={1}
                maxRows={5}
                type={'text'}
                name={''}
            />
            <PlatformInput
                label={'Текст'}
                value={item.data[0].text}
                handleChange={(e) => {
                    handleChange({
                        target: {
                            index: 0,
                            value: e.target.value,
                            item: item,
                            name: 'promo-text-image',
                            subname: 'text',
                        }
                    })
                }}
                isTextArea={true}
                minRows={1}
                maxRows={5}
                type={'text'}
                name={''}
            />
            {/* <p>image</p> */}
            <ImagesInput
                name={"image"}
                label={"Изображение"}
                hint={PROMO_IMAGE_HINT}
                addBtnText={"Добавить..."}
                isMultiple={false}
                images={item.data[0].image}
                additionalKey={`${item._id}_promo-text-picture`}
                onRemove={(e) => {
                    handleChange({
                        target: {
                            index: 0,
                            value: e.target.index,
                            item: item,
                            name: 'promo-text-image',
                            subname: 'image-delete',
                        }
                    })
                }}
                onAdd={(e) => {
                    handleChange({
                        target: {
                            index: 0,
                            ...e.target,
                            item: item,
                            name: 'promo-text-image',
                            subname: 'image',
                            files: e.target.files,
                        }
                    })
                }}
            />
            {item.block.input_data.image_tablet && item.block.input_data.image_tablet.editable ?
                <ImagesInput
                    name={"image_tablet"}
                    label={"Изображение для планшета"}
                    hint={PROMO_IMAGE_TABLET_HINT}
                    addBtnText={"Добавить..."}
                    isMultiple={false}
                    images={item.data[0].image_tablet}
                    additionalKey={`${item._id}_promo-text-picture_tablet`}
                    onRemove={(e) => {
                        handleChange({
                            target: {
                                index: 0,
                                value: e.target.index,
                                item: item,
                                name: 'promo-text-image',
                                subname: 'image-delete',
                                resolution: 'tablet',
                            }
                        })
                    }}
                    onAdd={(e) => {
                        handleChange({
                            target: {
                                index: 0,
                                ...e.target,
                                item: item,
                                name: 'promo-text-image',
                                subname: 'image',
                                files: e.target.files,
                                resolution: 'tablet',
                            }
                        })
                    }}
                />
                : null}
            {item.block.input_data.image_mobile && item.block.input_data.image_mobile.editable ?
                <ImagesInput
                    name={"image_mobile"}
                    label={"Изображение для телефона"}
                    hint={PROMO_IMAGE_MOBILE_HINT}
                    addBtnText={"Добавить..."}
                    isMultiple={false}
                    images={item.data[0].image_mobile}
                    additionalKey={`${item._id}_promo-text-picture_mobile`}
                    onRemove={(e) => {
                        handleChange({
                            target: {
                                index: 0,
                                value: e.target.index,
                                item: item,
                                name: 'promo-text-image',
                                subname: 'image-delete',
                                resolution: 'mobile',
                            }
                        })
                    }}
                    onAdd={(e) => {
                        handleChange({
                            target: {
                                index: 0,
                                ...e.target,
                                item: item,
                                name: 'promo-text-image',
                                subname: 'image',
                                files: e.target.files,
                                resolution: 'mobile',
                            }
                        })
                    }}
                />
                : null}
            <PlatformInput
                label={'Ссылка'}
                value={item.data[0].link}
                handleChange={(e) => {
                    handleChange({
                        target: {
                            index: 0,
                            value: e.target.value,
                            item: item,
                            name: 'promo-text-image',
                            subname: 'link',
                        }
                    })
                }}
                type={'text'}
                name={''}
            />
            <PlatformInput
                label={'Текст Кнопки'}
                value={item.data[0].btn_text}
                handleChange={(e) => {
                    handleChange({
                        target: {
                            index: 0,
                            value: e.target.value,
                            item: item,
                            name: 'promo-text-image',
                            subname: 'btn_text',
                        }
                    })
                }}
                type={'text'}
                name={''}
            />
        </div>
    );
}

export default PromoTextPicture
